import React from "react";
import { logOut, getUser } from "../auth/Auth";
import { Link } from "react-router";
import Storage from "../base/Storage";
import { translate } from "../base/Translation";

export default class NavigationUserMenu extends React.Component {

    constructor(props) {
        super(props);

        if ([2, 3, 5, 6, 7].indexOf(getUser().role) !== -1) {

            // Get weave groups, brands,...
            let brands = getUser().brands ? getUser().brands : [];
            let weaveGroups = getUser().weaveGroups ? getUser().weaveGroups : [];

            // Set defaults
            let active_brand_filter = Storage.get("brand_filter", true);
            let active_weaveGroup_filter = Storage.get("weaveGroup_filter", true);
            let active_weaves_filter = Storage.get("weaves_filter", true);

            let isWeaveGroupSelected = (active_weaveGroup_filter !== null && active_weaveGroup_filter !== false);

            if (isWeaveGroupSelected) {
                if (active_weaveGroup_filter.id === "all") {
                    isWeaveGroupSelected = false;
                }
            }

            let weaves = [];
            for (let i = 0; i < weaveGroups.length; i++) {

                if (isWeaveGroupSelected) {
                    if (active_weaveGroup_filter.id === weaveGroups[i].id) {
                        weaves = weaves.concat(weaveGroups[i].weaves);
                    }
                } else {
                    weaves = weaves.concat(weaveGroups[i].weaves);
                }
            }

            if(weaves.length ===  0  && typeof getUser().weaves !== "undefined"){
                weaves  = getUser().weaves;
            }

            // Set default name for brand filter
            let defaultName = translate("Všetky značky");

            // If role id is 2 than it's filter for branches
            if (getUser().role === 2) {
                defaultName = translate("Všetky prevádzky");
            }

            // Append show all item
            let show_all_brands = {
                id: "all",
                name: defaultName
            }
            brands.push(show_all_brands);

            // If nothing is selected, then select "all"
            if (active_brand_filter === null) {
                active_brand_filter = show_all_brands;
            }

            // Define default for weave groups
            let show_all_weaveGroups = {
                id: "all",
                name: translate("Všetky skupiny")
            }
            weaveGroups.push(show_all_weaveGroups);

            // If no weave group filter is active, then select "all"
            if (active_weaveGroup_filter === null) {
                active_weaveGroup_filter = show_all_weaveGroups;
            }

            // Define default for weaves
            let show_all_weaves = {
                id: "all",
                name: translate("Všetky vlny")
            }
            weaves.push(show_all_weaves);

            // If no weaves filter is active, then select "all"
            if (active_weaves_filter === null) {
                active_weaves_filter = show_all_weaves;
            }

            this.state = {
                active_brand_filter,
                brands,
                active_weaveGroup_filter,
                weaveGroups,
                active_weaves_filter,
                weaves
            }
        }
    }

    onBrandFilterClick() {
        Storage.set("brand_filter", this.brand);
        window.location.reload();
    }

    brandFilter() {
        if ([2, 3, 5, 6, 7].indexOf(getUser().role) !== -1) {
            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <span>{this.state.active_brand_filter.name}</span>&nbsp;&nbsp;
                            <i className="fa fa-caret-down" />
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                        {this.state.brands.map((brand) => {
                            if (brand.id === this.state.active_brand_filter.id) {
                                return false;
                            }
                            return (
                                <li key={brand.id + brand.name}>
                                    <a href="#" onClick={this.onBrandFilterClick.bind({ component: this, brand })}>{brand.name}</a>
                                </li>
                            )
                        })}
                    </ul>
                </li>
            )
        } else {
            return false;
        }
    }


    onWeaveGroupFilterClick() {
        Storage.set("weaveGroup_filter", this.item);
        Storage.del("weaves_filter");
        window.location.reload();
    }

    weaveGroupFilter() {
        if ([2, 3, 5, 6, 7].indexOf(getUser().role) !== -1) {
            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <span>{this.state.active_weaveGroup_filter.name}</span>&nbsp;&nbsp;
                            <i className="fa fa-caret-down" />
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                        {this.state.weaveGroups.map((item) => {
                            if (item.id === this.state.active_weaveGroup_filter.id) {
                                return false;
                            }
                            return (
                                <li key={item.id + item.name}>
                                    <a href="#" onClick={this.onWeaveGroupFilterClick.bind({ component: this, item })}>{item.name}</a>
                                </li>
                            )
                        })}
                    </ul>
                </li>
            )
        } else {
            return false;
        }
    }


    onWeavesFilterClick() {
        Storage.set("weaves_filter", this.item);
        window.location.reload();
    }

    weavesFilter() {
        if ([2, 3, 5, 6, 7].indexOf(getUser().role) !== -1) {
            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <span>{this.state.active_weaves_filter.name}</span>&nbsp;&nbsp;
                            <i className="fa fa-caret-down" />
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                        {this.state.weaves.map((item) => {
                            if (item.id === this.state.active_weaves_filter.id) {
                                return false;
                            }
                            return (
                                <li key={item.id + item.name}>
                                    <a href="#" onClick={this.onWeavesFilterClick.bind({ component: this, item })}>{item.name}</a>
                                </li>
                            )
                        })}
                    </ul>
                </li>
            )
        } else {
            return false;
        }
    }

    handbook() {
        if ([4, 5, 6, 7].indexOf(getUser().role) !== -1) {
            return (
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <span>{translate("Návody")}</span>&nbsp;&nbsp;
                            <i className="fa fa-caret-down" />
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                        <li>
                            <a href="https://api.trend.toptest.eu/uploads/mystery_shopper_manual.pdf" target="_blank">{translate("Príručka mystery shoppera")}</a>
                        </li>
                        <li>
                            <a href="https://api.trend.toptest.eu/uploads/trend_user_manual.pdf" target="_blank">{translate("Krátky manuál")}</a>
                        </li>
                        <li>
                            <a href="https://api.trend.toptest.eu/uploads/visit_scenario.pdf" target="_blank">{translate("Scenár návštevy")}</a>
                        </li>
                    </ul>
                </li>
            )
        }
    }


    render() {
        return (
            <ul className="nav navbar-top-links navbar-right">
                {this.handbook()}
                {getUser().role >= 5 ? this.weaveGroupFilter() : ""}
                {getUser().role >= 5 || getUser().role === 3 ? this.weavesFilter() : ""}
                {getUser().role === 2 ? this.brandFilter() : ""}
                <li className="dropdown">
                    <a className="dropdown-toggle" data-toggle="dropdown" href="#">
                        <i className="fa fa-user fa-fw"></i>&nbsp;
                            <span>{getUser().name} {getUser().surname}</span>
                        &nbsp;&nbsp;<i className="fa fa-caret-down"></i>
                    </a>
                    <ul className="dropdown-menu dropdown-user">
                        <li>
                            <Link to="/users/profile"><i className="fa fa-user fa-fw"></i> {translate("Profil")}</Link>
                        </li>
                        <li className="divider"></li>
                        <li>
                            <a href="/" onClick={logOut}><i className="fa fa-sign-out fa-fw"></i> {translate("Odhlásenie")}</a>
                        </li>
                    </ul>
                </li>
            </ul>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/navigation/NavigationUserMenu.js